import React, { useEffect } from "react";
import { MultiStepItemProps } from "@ucl/library";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { AppToasterV2 } from "@ucl/library";
import { OptIns } from "./OptIns";
import "./OptInsFormStep.scss";
import { FinancialApplicationSection } from "@/types/enums";
import { useFinancialApplicationFormSectionValidation, FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface OptInsFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const OptInsFormStep: React.FC<OptInsFormStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <OptInsFormStepInner {...props} />
    </RequireAuth>
  );
};

const OptInsFormStepInner: React.FC<OptInsFormStepProps> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.OptIns
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection, props.registerSubmit]);

  return (
    <section className="opt-ins step-section">
      <div className="opt-ins__header step-header">Account Features & Preferences</div>
      <div className="opt-ins__subtitle step-subtitle">
        Please choose the services and settings you would like to enable for your account(s).
      </div>
      <div className="opt-ins-form__content step-content">
        <OptIns
          financialApplicationId={props.financialApplicationId}
          initiallyCollapsed
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        />
      </div>
    </section>
  );
};
